import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { RelationType } from 'ogp/hooks/queryHooks/flexWorkers/useGetFlexWorkerProfile';
import { DateTime } from 'luxon';
import { PreferredWorkerColumnDefinition } from './preferred-worker-table.types';
import { VisibilityRule } from '../preferred-worker.types';
import { defaultCheckedInIndicator } from '../../shared/types/shift-detail-tables.types';

export const getPreferredWorkersTableData = (
  visibilityRules: VisibilityRule[]
): PreferredWorkerColumnDefinition[] => {
  return visibilityRules.flatMap((rule) =>
    rule.workers.map((worker) => ({
      flexWorkerFullName: getFullNameWithInfix(worker),
      flexWorkerImage: {
        firstName: worker.firstName,
        lastName: worker.lastName,
        infix: worker.infix,
        imageUrl: worker.imageUrl,
        id: worker.id,
        relation: {
          id: worker.id,
          relation: RelationType.PREFERRED_WORKER,
        },
        isFlexWorker: false,
        hasCandidateLevel: false,
        partnerName: worker.partnerName,
        isReplacement: false,
        employmentType: worker.employmentType,
        lenderCompanyName: null,
        includeCheckedInIndicator: defaultCheckedInIndicator,
      },
      status: worker.status,
      dateTime: {
        fromDateTime: DateTime.fromISO(rule.isoRuleStartTime),
        toDateTime: DateTime.fromISO(rule.isoRuleEndTime),
      },
    }))
  );
};
